import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = none, {} = user
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("itcot_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("itcot_token");
        setUser(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const loginAdmin = async (username, password) => {
    const r = await api.post("/auth/admin/login", { username, password });
    localStorage.setItem("itcot_token", r.data.token);
    const me = await api.get("/auth/me");
    setUser(me.data);
    return me.data;
  };

  const loginWorker = async (workerId, password) => {
    const r = await api.post("/auth/worker/login", {
      username: workerId,
      password,
    });
    localStorage.setItem("itcot_token", r.data.token);
    const me = await api.get("/auth/me");
    setUser(me.data);
    return me.data;
  };

  const logout = () => {
    localStorage.removeItem("itcot_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider
      value={{ user, setUser, loading, loginAdmin, loginWorker, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
